import { useEffect } from 'react';
export function useTermsModalBlockEscapeKey(isOpen) {
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        const blockEscapeClose = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        document.addEventListener('keydown', blockEscapeClose, true);
        return () => {
            document.removeEventListener('keydown', blockEscapeClose, true);
        };
    }, [isOpen]);
}
